import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './Button';
import { PS, T } from '../lib/theme';

export function RequireAdmin() {
  const { firebaseUser, isAdmin, loading, signOut } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ padding: 32, ...T.ui, color: PS.textSec }}>Loading…</div>
    );
  }

  if (!firebaseUser) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (isAdmin === false) {
    return (
      <div
        style={{
          padding: 32,
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          alignItems: 'flex-start',
        }}
      >
        <h1 style={{ ...T.sectionTitle, color: PS.danger, margin: 0 }}>Not authorized</h1>
        <p style={{ ...T.ui, color: PS.textSec, margin: 0 }}>
          Your account ({firebaseUser.email ?? 'unknown'}) is signed in, but does not have admin
          access. Ask an existing admin to grant your account access, then sign out and sign in again.
        </p>
        <Button variant="secondary" onClick={() => void signOut()}>
          Sign out
        </Button>
      </div>
    );
  }

  return <Outlet />;
}
